import React from 'react';
import { Card, Image, Header, Icon, Button } from 'semantic-ui-react';
import ExternalLinkButton from '../../../UtilityComponents/ExternalLinkButton/index';

const HospitalCard = ({
  hasImage,
  hasSector,
  hasFindButton,
  hasRouteButton,
  hospital: {
    name,
    address,
    sector,
    openingHours,
    telNumbers,
    id,
    location,
    distanceFromCurrentLocation,
    routeLink,
  },
  changeMapCenter,
}) => {
  const distance = distanceFromCurrentLocation > 1000
    ? `${Math.round((distanceFromCurrentLocation / 1000) * 100) / 100}km`
    : `${distanceFromCurrentLocation}m`;
  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>
          {hasFindButton
            && (
              <Button
                content="Vind op map"
                floated="right"
                size="mini"
                onClick={() => changeMapCenter(location)}
              />
            )
          }
          {hasImage && (
            <Image
              src={require(`../../../../assets/images/markers/redMarker_${id}.png`)}
            />
          )
          }
          {` ${name}`}
        </Card.Header>
        <Card.Description>{address}
          {hasRouteButton
          && (
          <ExternalLinkButton
            text="Route"
            floated="right"
            size="mini"
            link={routeLink}
          />
          )
          }
        </Card.Description>
        <Card.Description>Afstand: {distance}</Card.Description>
        {hasSector
          && <Card.Meta>{sector}</Card.Meta>
        }
      </Card.Content>
      <Card.Content>
        <Header
          sub
          icon="clock outline"
          textAlign="center"
          content="Openingsuren"
        />
        {openingHours.map((item) => {
          return (
            <p key={item}>{item}</p>
          );
        })}
      </Card.Content>
      <Card.Content textAlign="center">
        <Icon name="phone" />
        {telNumbers.map((number, index) => {
          const text = index === 0 ? number : ` | ${number}`;
          return (
            `${text}`
          );
        })}
      </Card.Content>
    </Card>
  );
};

export default HospitalCard;



// WEBPACK FOOTER //
// ./src/components/Hospitals/SubComponents/Cards/HospitalCard.js